
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/surah/[chapterId]/info",
      function () {
        return require("private-next-pages/surah/[chapterId]/info.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/surah/[chapterId]/info"])
      });
    }
  